import * as React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import Apartments from './modules/views/Apartment/Apartments';
import ApartmentDetail from './modules/views/Apartment/ApartmentDetail';
import Footer from './modules/views/Footer';
import ProductHero from './modules/views/Hero/Hero';
import ProductValues from './modules/views/ProductValues';
import AppAppBar from './modules/views/AppAppBar';
import Contacts from './modules/views/Contacts';
import Pricelist from './modules/views/PriceList';
import withRoot from './modules/withRoot';
import i from './locales/i18n';
import ProductSmokingHero from './modules/views/ProductSmokingHero';
import ScrollButton from './modules/components/ScrollButton';
import useLocaleDetection from './hooks/useLocaleDetection';
import useSEO from './modules/components/SEO';

function HomePage() {
  return (
    <>
      <ProductHero />
      <Apartments />
      <Pricelist />
      <ProductValues />
      <Contacts />
      <ProductSmokingHero />
    </>
  );
}

function Layout({ children }) {
  return (
    <>
      <AppAppBar />
      {children}
      <Footer />
      <ScrollButton />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function AppContent() {
  useLocaleDetection();
  useSEO();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/:locale/" element={<HomePage />} />
      <Route path="/:locale/rooms/:slug/" element={<ApartmentDetail />} />
      <Route path="/rooms/:slug/" element={<ApartmentDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i}>
      <Router>
        <ScrollToTop />
        <Layout>
          <AppContent />
        </Layout>
      </Router>
    </I18nextProvider>
  );
}

export default withRoot(App);
